import React from 'react';

import { IQuestion } from 'modules/national-certificate';

import TopSection from '../top-section';

import { OptionsWithInput } from './options-with-input';
import TextSection from './text-section';

interface IProps {
  data?: IQuestion;
  subject?: string;
}

const InputTest: React.FC<IProps> = ({ data, subject }) => (
  <div className="shadow-xs space-y-4 rounded-xl bg-white px-4 py-3">
    <TopSection checked={1} subject={subject} testImage={data?.image} questionId={data?.question_id} title={data?.question_name} />
    <TextSection description={data?.description} />
    <OptionsWithInput test={data?.sub_questions} />
  </div>
);

export default InputTest;
